(() => {
  if (customElements.get('idc-promo-bar')) return;
  class PromoBar extends HTMLElement {
    connectedCallback() {
      this.editor = this.dataset.designMode === 'true';
      this.clock = this.querySelector('[data-bar-timer]');
      this.note = this.querySelector('[data-bar-note]');
      const { date, time, zone, section } = this.dataset;
      const stamp = date && /^\d{2}:\d{2}$/.test(time) && /^[+-]\d{2}:\d{2}$/.test(zone) ? `${date}T${time}${zone}` : '';
      this.end = this.dataset.countdown === 'true' ? window.IDCPdp?.deadline(stamp) : null;
      this.key = `idc-bar:${section}:${stamp}:${this.querySelector('.idc-bar__copy')?.textContent.trim()}`;
      this.dismissed = false;
      try { this.dismissed = !this.editor && sessionStorage.getItem(this.key) === '1'; } catch (_) { /* Storage may be unavailable. */ }
      this.onClick = event => {
        if (!event.target.closest('[data-bar-close]')) return;
        if (this.editor) return; // Keep the bar editable in Shopify's canvas.
        this.dismissed = true;
        this.hidden = true;
        clearInterval(this.timer);
        try { sessionStorage.setItem(this.key, '1'); } catch (_) { /* Nonessential preference. */ }
      };
      this.addEventListener('click', this.onClick);
      this.tick();
      if (this.end && this.end > Date.now() && !this.dismissed) this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.removeEventListener('click', this.onClick);
    }
    tick() {
      const expired = this.end && this.end <= Date.now();
      this.hidden = this.dismissed || (!!expired && !this.editor);
      if (!this.clock) return;
      if (!this.end || expired) {
        this.clock.hidden = !(this.editor && this.dataset.countdown === 'true');
        for (const unit of this.clock.querySelectorAll('[data-bar-unit]')) unit.textContent = '—';
        if (this.note) this.note.hidden = this.clock.hidden;
        clearInterval(this.timer);
        return;
      }
      this.clock.hidden = false;
      if (this.note) this.note.hidden = true;
      const seconds = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [key, value] of Object.entries(values)) {
        const node = this.clock.querySelector(`[data-bar-unit="${key}"]`);
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      }
    }
  }
  customElements.define('idc-promo-bar', PromoBar);
})();
